import StorageFileItem from './StorageFileItem';

export default StorageFileItem;
